import { plainToClass } from "class-transformer";
import EshopRequestBuilder from "data/eshopRequestBuilder";
import EshopError from "../models/eshopError";
import AuthorizationService from "../services/authorizationService";
import RepositoryBase from "./repositoryBase";
import EventBus from "../services/eventBus";
import IsdsMessageDeliveryStatusResponse from "entities/isdsMessageDeliveryStatusResponse";

export default class ISDSRepository extends RepositoryBase<EshopRequestBuilder> {
  constructor(
    protected apiFactory: ReturnType<typeof EshopRequestBuilder.Factory>,
    protected authorizationService: AuthorizationService,
    protected eventBus: EventBus
  ) {
    super(() => apiFactory(), authorizationService, eventBus);
  }

  conceptStatus = (sessionId: string) =>
    this.callApi(api =>
      api
        .apiVersion(3)
        .one("isds/message_status")
        .clearGet({}, undefined, undefined, sessionId)
        .then(async response => {
          if (!response.ok) return plainToClass(EshopError, (await response.json()) as EshopError);

          return plainToClass(IsdsMessageDeliveryStatusResponse, (await response.json()) as IsdsMessageDeliveryStatusResponse);
        })
    );
}
